<template>
  <div class="base-progress-liner__bar" :class="classes">
    <div class="base-progress-liner__bar__wrapper" :style="styles">
      <div class="base-progress-liner__bar__bubble__wrapper" v-if="value">
        <div class="base-progress-liner__bar__bubble__bubble">{{ value }}</div>
      </div>
      <div class="base-progress-liner__bar__body__wrapper" :class="bodyClasses">
        <div class="base-progress-liner__bar__dot__wrapper">
          <div class="base-progress-liner__bar__dot__dot" />
        </div>
        <div class="base-progress-liner__bar__body" />
      </div>
    </div>
  </div>
</template>

<script>
import cssVars from '@/assets/css/exports.scss';

export default {
  name: 'BaseProgressLinerBar',
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    width: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: cssVars.cGreenBase,
    },
  },
  computed: {
    computedWidth() {
      // bubbleの位置の調整が面倒なので、いい感じの位置になる3%までは全て3%とする
      // かつ100が最大
      return `${Math.min(Math.max(this.width, 3), 100)}%`;
    },
    classes() {
      return {
        slim: !this.value,
      };
    },
    bodyClasses() {
      // computedWidthの影響で0%の時もbarが表示色されてしまうので0を超えた時のみ表示
      return {
        active: this.width !== 0,
      };
    },
    styles() {
      return {
        width: this.computedWidth,
        '--color': this.color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.base-progress-liner__bar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: $progressbar_h-bar + $progressbar_h-bubble-area;
  transition: 0.2s;
  width: 100%;
  z-index: 1;

  &.slim {
    height: $progressbar_h-bar;
  }

  &__body {
    height: $progressbar_h-bar;
    transition: 0.2s;
    border-radius: 6px;

    background-color: var(--color);
    border-color: var(--color);

    &__wrapper {
      position: relative;
      display: none;

      &.active {
        display: block;
      }
    }
  }

  &__dot {
    &__wrapper {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 3px;
    }

    &__dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: white;
      margin-right: 3px;
    }
  }

  &__bubble {
    &__wrapper {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: baseline;
      height: $progressbar_h-box + $progressbar_h-bubble;
      margin-bottom: $progressbar_mb-wrapper;
      margin-left: 7px;
    }

    &__bubble {
      // 箱
      position: relative;
      background: var(--color);
      min-width: 32px;
      max-width: 32px;
      height: $progressbar_h-box;
      border-radius: 2px;
      padding: 3px;
      color: $c-bg;
      font-size: 10px;
      font-weight: bold;
      text-align: center;

      &:after {
        // 吹き出し
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: $progressbar_h-bubble solid transparent;
        border-top-color: var(--color);
        border-bottom: 0;
        margin-left: -$progressbar_h-bubble;
        margin-bottom: -$progressbar_h-bubble;
      }
    }
  }
}
</style>
